import {FONT_PROXIMA_12, FONT_PROXIMA_13, FONT_WEIGHT_PROXIMA_SEMIBOLD} from 'styles/FontConstants';
import {BLUE_LIGHT, GRAY_DARKER} from 'ui-library/Colors';

export const BASIC_MARGIN = '17px';
export const ICON_COLOR = {color: BLUE_LIGHT};
export const BASE_GRAY_COLOR = {color: GRAY_DARKER};
export const BASE_TEXT = {...FONT_PROXIMA_13, ...BASE_GRAY_COLOR};
export const BASE_DETAIL_TEXT = {...FONT_PROXIMA_12, ...BASE_GRAY_COLOR};
export const SEMIBOLD_DETAIL_TEXT = {...BASE_DETAIL_TEXT, fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD};
export const COL_PADDING_OFFSET = {margin: `0px -15px`};
export const MAX_WIDTH_100 = {maxWidth: '100%'};
export const FULL_WIDTH_MODAL_RULE = {margin: `${BASIC_MARGIN} -16px`};
export const BASIC_VERTICAL_MARGIN = {margin: `${BASIC_MARGIN} 0px`};
export const WITHOUT_BUTTON_FOCUS_STYLING = {':focus': {textDecoration: 'none'}};
export const CLICKABLE = {':hover': {cursor: 'pointer'}};
